import React from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <img
                src="/assets/img/logo-white.png"
                alt="Trademark Claim Experts"
                className="h-12 w-auto"
              />
            </Link>

            <p className="text-sm mb-4">
              Helping businesses across the United States protect their brands
              with dependable trademark registration and intellectual property
              services.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">
              Our Services
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/trademark-registration"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link
                  to="/copyright-registration"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link
                  to="/trademark-search"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link
                  to="/amazon-brand-registry"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Amazon Brand Registry
                </Link>
              </li>
              <li>
                <Link
                  to="/company-formation"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Company Formation
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about-us"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact-us"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-conditions"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  535 Mission St San Francisco, CA 94105
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
                <a
                  href="tel:+18778866927"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  1-877-886-6927
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-2 flex-shrink-0" />
                <a
                  href="mailto:info@trademarkclaimexperts.com"
                  className="text-sm hover:text-brand-pink transition-colors"
                >
                  info@trademarkclaimexperts.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-sm">
          <p>
            &copy; {currentYear} Trademark Claim Experts. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
